type IntersectionParams = {
  handler: IntersectionObserverCallback;
} & IntersectionObserverInit;

export const intersection = (node: HTMLElement, { handler, ...options }: IntersectionParams) => {
  let observer = new IntersectionObserver(handler, options);
  observer.observe(node);

  return {
    destroy: () => {
      observer.unobserve(node);
    },
    update: ({ handler, ...options }: IntersectionParams) => {
      observer.unobserve(node);
      observer = new IntersectionObserver(handler, options);
      observer.observe(node);
    },
  };
};
